import './assets/slick.1.9.0.min.js';
//import slickCss from 'slick-carousel/slick/slick.css';

class NewsTeaser {
  constructor($main) {
    console.log('NewsTeaser');
    if (!this.initDomElements($main)) return false;
    this.initSlider();
  }

  initDomElements($main) {
    this.domElements = {};
    this.domElements.main = $main;
    if (this.domElements.main.length < 1) return false;
    this.domElements.inside = this.domElements.main.find('.news.teaser__inside');
    this.domElements.items = this.domElements.main.find('.news-teaser__items__inside');
    this.domElements.navigation = this.domElements.main.find('.news-teaser__controls');
    return true;
  }

  initSlider() {
    console.log('initSlider');
    //
    // if (this.domElements.items.find('>*').length < 2) {
    //   return;
    // }


    const options = {
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      fade: false,
      autoplay: false,
      adaptiveHeight: true,
      appendArrows: this.domElements.navigation,
      appendDots: this.domElements.navigation,
      nextArrow: '<button class="slick-next slick-arrow" aria-label="weiter" type="button" style="">weiter</button>',
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="zurück" type="button" style="">zurück</button>'
//      lazyLoad: 'ondemand'
    };

    const slider = this.domElements.items.slick(options);

    this.domElements.items.find('img').on('load', () => {
      slider.slick('unslick');
      slider.slick(options);
    });
  }
}

export default NewsTeaser;
